import { render, staticRenderFns } from "./PageJiFen.vue?vue&type=template&id=2a2e7171&scoped=true&"
import script from "./PageJiFen.vue?vue&type=script&lang=js&"
export * from "./PageJiFen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2e7171",
  null
  
)

export default component.exports